// extracted by mini-css-extract-plugin
module.exports = {"container":"productSlider_container__gPFFX","title":"productSlider_title__GgHQu","withLink":"productSlider_withLink__kYGbl","cartPage":"productSlider_cartPage__XsE__"};